/**
 * Field-scoped autosave failure. Handlers throw this when specific field paths
 * failed but other work in the same handler may have completed successfully.
 */
export class AutosaveFieldFailureError extends Error {
  readonly failedFields: Set<string>;

  constructor(failedFields: Set<string>, cause?: unknown) {
    const fields = [...failedFields].join(", ");
    super(
      fields.length > 0
        ? `Autosave failed for: ${fields}`
        : "Autosave field failure",
    );
    this.name = "AutosaveFieldFailureError";
    this.failedFields = failedFields;
    if (cause !== undefined) {
      Object.defineProperty(this, "cause", {
        value: cause,
        configurable: true,
      });
    }
  }
}

export function isAutosaveFieldFailure(
  error: unknown,
): error is AutosaveFieldFailureError {
  return error instanceof AutosaveFieldFailureError;
}
